module.exports = __webpack_public_path__ + "img/project-logo.f87b25a6.png";